import FilterField from '../LoadFilters/FilterField';
import {
  getMinDate,
  getMaxDate,
  hasAnyFilterSelected,
  getFilterMinLengthError,
  hasFilterMinLengthErrors,
} from '../LoadFilters/utils';
import PropTypes from 'prop-types';

const styles = {
  fields: 'd-flex gap-4 justify-content-between',
  column: 'd-flex flex-column gap-2 flex-grow-1',
  dateField: 'd-flex gap-2',
};

const NeeNorFilters = ({ visible, values, onChange, onSubmit }) => {
  const handleChange = (e) => {
    onChange((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  if (!visible) return null;

  const applyDisabled = !hasAnyFilterSelected(values) || hasFilterMinLengthErrors(values);

  return (
    <div className="px-3 mt-4">
      <div className={styles.fields}>
        <div className={styles.column}>
          <FilterField
            label="COMPANY NAME"
            field="companyName"
            value={values.companyName}
            onChange={handleChange}
            error={getFilterMinLengthError('companyName', values.companyName)}
          />
          <FilterField
            label="EORI NUMBER"
            field="eori"
            value={values.eori}
            onChange={handleChange}
            error={getFilterMinLengthError('eori', values.eori)}
          />
        </div>
        <div className={styles.column}>
          <FilterField label="SHORT CODE" field="shortCode" value={values.shortCode} onChange={handleChange} />
          <div className={styles.dateField}>
            <FilterField
              type="date"
              label="LAST UPDATED (From)"
              field="lastModifiedFrom"
              value={values.lastModifiedFrom}
              onChange={handleChange}
              min={values.lastModifiedTo ? getMinDate(values.lastModifiedTo) : undefined}
              max={values.lastModifiedTo || undefined}
            />
            <FilterField
              type="date"
              label="To"
              field="lastModifiedTo"
              value={values.lastModifiedTo}
              onChange={handleChange}
              min={values.lastModifiedFrom || undefined}
              max={values.lastModifiedFrom ? getMaxDate(values.lastModifiedFrom) : undefined}
            />
          </div>
        </div>
      </div>
      <div className="text-end mb-3">
        <button className="stepper-button yellow" onClick={onSubmit} disabled={applyDisabled}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

NeeNorFilters.propTypes = {
  visible: PropTypes.bool,
  values: PropTypes.shape({
    companyName: PropTypes.string,
    eori: PropTypes.string,
    shortCode: PropTypes.string,
    lastModifiedFrom: PropTypes.string,
    lastModifiedTo: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default NeeNorFilters;
